class RegisterInterest extends HTMLElement {
	static forms = new Map();

	constructor() {
		super();

		const form = this.children[0];
		const formId = [...form.classList].find(c => c.startsWith('klaviyo-form-'))?.split('-')[2] ?? 'default';

		const mutObserver = new MutationObserver(mutations => {
			if (form.classList.contains('klaviyo-form')) RegisterInterest.forms.set(formId, form);
		});

		mutObserver.observe(form, { attributes: true });
		if (form.classList.contains('klaviyo-form')) RegisterInterest.forms.set(formId, form);

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					if (RegisterInterest.forms.has(formId)) {
						this.innerHTML = '';
						this.appendChild(RegisterInterest.forms.get(formId));
					}
				}
			});
		});

		observer.observe(this);
	}
}

customElements.define('register-interest', RegisterInterest);